import LinearGradient from "react-native-linear-gradient"
import React, { useState, useEffect } from "react"
import { VoucherContainerProp } from "./props"
import { style } from "./styles"
import { useColor } from "app/theme/getThemes"

import { Text } from "components/Text"
import { View, Image, TouchableOpacity } from "react-native"
import moment from "moment"
import { translate } from "i18n"
import Svg, { Line } from "react-native-svg"
import expired from "assets/expired-new.png"
import claimed from "assets/claimed-new.png"
import fullyClaimed from "assets/outofstock-new.png"
import used from "assets/used.png"
import inProgress from "assets/in-progress.png"
import { colors } from "colors"

export const VoucherContainerV2 = (props: VoucherContainerProp) => {
  const {
    voucherName,
    voucherDescription,
    voucherPointReq,
    voucherImg,
    voucherStartDate,
    isHistory,
    voucherExpiredDate,
    useAt,
    isPromotion,
    isRedeemed,
    isExpired,
    isEmpty,
    isUsed,
    onPress,
    onRefresh,
    currentLocation,
  } = props

  const { companyTheme } = useColor()

  return (
    <>
      <TouchableOpacity onPress={onPress}>
        <LinearGradient
          style={style.voucherContentContainer}
          colors={[companyTheme.first, companyTheme.second]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          {/* {isHistory || currentLocation === "voucher"
            ? null
            : isSevenDayFromStart && <AnimatedNewBadge />} */}

          <View style={style.row}>
            <View style={style.voucherContainer}>
              <Text style={style.voucherTitleText} numberOfLines={2}>
                {voucherName}
              </Text>

              {currentLocation === "voucher" && (
                <Text style={style.expiryText}>
                  {isHistory
                    ? `${
                        useAt
                          ? translate("voucherScreen.usedOn")
                          : translate("voucherScreen.expiredOn")
                      } ${moment(useAt || voucherExpiredDate).format("DD-MM-YYYY")}`
                    : `${translate("voucherScreen.expiry")}: ${moment(voucherExpiredDate).format(
                        "DD-MM-YYYY",
                      )}`}
                </Text>
              )}

              <View style={style.dottedLine}>
                <Svg height="2" width="100%">
                  <Line
                    x1="0"
                    y1="0"
                    x2="100%"
                    y2="0"
                    stroke="white"
                    strokeWidth="2"
                    strokeDasharray="5, 4" // Adjust dash length and spacing
                  />
                </Svg>
              </View>

              {voucherPointReq > 0 && !isHistory && (
                <Text style={[style.voucherText, { color: colors.white }]}>
                  {voucherPointReq + " pts"}
                </Text>
              )}
              <Text style={[style.voucherText, { color: colors.white }]} numberOfLines={1}>
                {voucherDescription}
              </Text>
            </View>

            <View style={{ width: 90 }}>
              {!(currentLocation === "voucher") ? (
                <Image
                  source={{
                    uri: voucherImg,
                  }}
                  resizeMode="cover"
                  style={style.image}
                />
              ) : (
                <>
                  {isHistory ? (
                    <>
                      <Image
                        source={{
                          uri: voucherImg,
                        }}
                        resizeMode="cover"
                        style={[style.image, { tintColor: "gray" }]}
                      />
                      <Image
                        source={{
                          uri: voucherImg,
                        }}
                        resizeMode="cover"
                        style={[style.image, { opacity: 0.3, position: "absolute" }]}
                      />
                    </>
                  ) : (
                    <View style={{ justifyContent: "center" }}>
                      <Image
                        source={{
                          uri: voucherImg,
                        }}
                        resizeMode="cover"
                        style={style.image}
                      />
                    </View>
                  )}
                </>
              )}
            </View>
          </View>

          {!isPromotion && (
            <>
              <View style={style.leftCurved}></View>
              <View style={style.rightCurved}></View>
            </>
          )}
        </LinearGradient>
        {/* expired and claimed */}

        {(isRedeemed || isExpired || isEmpty || isUsed) && (
          <Image
            source={
              isUsed && useAt && moment().diff(moment(useAt), "minutes") < 15
                ? inProgress
                : isUsed
                ? used
                : isExpired
                ? expired
                : isRedeemed
                ? claimed
                : fullyClaimed
            }
            resizeMode="contain"
            style={style.expiredClaimedImagev2}
          />
        )}
      </TouchableOpacity>
    </>
  )
}
